import { scheduledTasks as ContractScheduledTasks } from '../ducks/contract.duck'
import { scheduledTasks as AuthScheduledTasks } from '../ducks/auth.duck'
const timerTickIntervalSec = Number(process.env.REACT_APP_CLOCK_INTERVAL);
const appcuesEnabled = process.env.REACT_APP_APPCUES_ENABLED === "true";

export default class Scheduler {
    static StartClock = () => {
        if (this.timerId) {
            clearInterval(this.timerId);
        }
        this.timerId = setInterval(Scheduler.ApplicationClock, (timerTickIntervalSec * 1000));
        this.timer_20 = setTimeout(Scheduler.Timeout20Sec, 20 * 1000);
        this.timer_30 = setTimeout(Scheduler.Timeout30Sec, 30 * 1000);
        this.timer_40 = setTimeout(Scheduler.Timeout40Sec, 40 * 1000);
    }
    static StopClock = () => {
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            if (this.timer_20) {
                clearTimeout(this.timer_20);
            }
            if (this.timer_30) {
                clearTimeout(this.timer_30);
            }
            if (this.timer_40) {
                clearTimeout(this.timer_40);
            }
    }

    static ApplicationClock = () => {
        ContractScheduledTasks();
        AuthScheduledTasks();
    }
    static Timeout20Sec = () => {
        if (appcuesEnabled && window.Appcues) {
            window.Appcues.track("LOGIN_20SEC");
        }
    }
    static Timeout30Sec = () => {
        if (appcuesEnabled && window.Appcues) {
            window.Appcues.track("LOGIN_30SEC");
        }
    }
    static Timeout40Sec = () => {
        if (appcuesEnabled && window.Appcues) {
            window.Appcues.track("LOGIN_40SEC");
        }
    }
}